const handleSmoothScroll = (e) => {
  const href = e.currentTarget.getAttribute('href');
  
  if (!href?.startsWith('#') || href.includes('.')) return;
  
  e.preventDefault();
  const targetElement = document.getElementById(href.slice(1));
  targetElement?.scrollIntoView({ behavior: 'smooth' });
};

document.querySelectorAll('a').forEach(link => {
  link.addEventListener('click', handleSmoothScroll);
});